import { IntlShape } from "react-intl";
import { createColumnHelper, ColumnDef } from "types/common/Header";
import { TerritoryManager } from "./models/response/get-territory-managers-response";
import { TERRITORY_MANAGER_SORT_KEYS } from "./territory-manager.constants";

const columnHelper = createColumnHelper<TerritoryManager>();

export const getTerritoryManagerHeaders = (
  intl: IntlShape
): ColumnDef<TerritoryManager>[] => [
  columnHelper.accessor("name", {
    displayName: intl.formatMessage({ id: "baseTable.name" }),
    sortable: true,
    sortKey: TERRITORY_MANAGER_SORT_KEYS.NAME,
    alignRight: false,
    cell: (row) => <span>{row.name}</span>,
  }),
  columnHelper.accessor("email", {
    displayName: intl.formatMessage({ id: "baseTable.email" }),
    sortable: true,
    sortKey: TERRITORY_MANAGER_SORT_KEYS.EMAIL,
    alignRight: false,
    cell: (row) => <span>{row.email}</span>,
  }),
];
